import { AfterViewInit, Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[fit-children-height]',
    standalone: false
})
export class FitChildrenHeightDirective implements AfterViewInit {

    constructor(private el: ElementRef) { }

    @HostListener('window:resize', ['$event'])
    onResize(): void {
        this.resizeElementToFitChildHeight();
    }

    ngAfterViewInit(): void {
        this.resizeElementToFitChildHeight();
    }

    private resizeElementToFitChildHeight() {
        if (this.el?.nativeElement?.children && this.el.nativeElement.childElementCount > 0) {

            let calculated = 0;

            for (let i = 0; i < this.el.nativeElement.childElementCount; i++) {
                const element = this.el.nativeElement.children[i];
                if (element.clientHeight > 0) {
                    calculated += element.clientHeight;
                }
            }

            if (calculated > 0) {
                this.el.nativeElement.style.height = calculated + 'px';
            }
        }
    }
}
